import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as Endpoints from "../../entities/Endpoints";
import axiosStripePublicInstance from "../../services/axiosStripePublicInstance";
import { message } from "antd";
 
// Async thunk to fetch mobile app details
export const fetchMobileAppDetails = createAsyncThunk(
  "onboarding/fetchMobileAppDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosStripePublicInstance.get(
        Endpoints.GET_MOBILE_APP_DETAILS
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch mobile app details"
      );
    }
  }
);
 
export const fetchCoachOnboardingProcessThunk = createAsyncThunk(
  `${Endpoints.GET_COACH_ONBOARDING_PROCESS}`,
  async ({ offerID }, { rejectWithValue }) => {
    try {
      const response = await axiosStripePublicInstance.post(
        `${Endpoints.GET_COACH_ONBOARDING_PROCESS}?${offerID}`
      );
      if(response.data.type==='failed'){
      return rejectWithValue(
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-2xl p-8 text-center max-w-md">
        <h2 className="text-3xl font-bold text-red-600 mb-4">
          Failed ❌
        </h2>
        <p className="text-xl text-gray-700 mb-6">
          {response.data.message}
        </p>
      </div>
    </div>
  );
      }
      return response.data;
    } catch (error) {
      
      return rejectWithValue(
        error.response?.data?.message ||
          "Failed to fetch coach onboarding process"
      );
    }
  }
);
 
export const fetchCoachOneTimeFeeThunk = createAsyncThunk(
  `${Endpoints.GET_COACH_ONE_TIME_FEE}`,
  async ({ offerID }, { rejectWithValue }) => {
    try {
      const response = await axiosStripePublicInstance.post(
        `${Endpoints.GET_COACH_ONE_TIME_FEE}?offerID=${offerID}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch coach one time fee"
      );
    }
  }
);
 
const onboardingSlice = createSlice({
  name: "onboarding",
  initialState: {
    mobileAppDetails: null,
    coachOnboardingProcess: null,
    coachOneTimeFee: null,
    loading: false,
    loadingOnboardingProcess: false,
    loadingOneTimeFee: false,
    error: null,
    onboardingProcessError: null,
    oneTimeFeeError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Mobile App Details cases
      .addCase(fetchMobileAppDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMobileAppDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.mobileAppDetails = action.payload;
      })
      .addCase(fetchMobileAppDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Coach Onboarding Process cases
      .addCase(fetchCoachOnboardingProcessThunk.pending, (state) => {
        state.loadingOnboardingProcess = true;
        state.onboardingProcessError = null;
      })
      .addCase(fetchCoachOnboardingProcessThunk.fulfilled, (state, action) => {
        state.loadingOnboardingProcess = false;
        state.coachOnboardingProcess = action.payload;
      })
      .addCase(fetchCoachOnboardingProcessThunk.rejected, (state, action) => {
        state.loadingOnboardingProcess = false;
        state.onboardingProcessError = action.payload;
      })
      // Coach One Time Fee cases
      .addCase(fetchCoachOneTimeFeeThunk.pending, (state) => {
        state.loadingOneTimeFee = true;
        state.oneTimeFeeError = null;
      })
      .addCase(fetchCoachOneTimeFeeThunk.fulfilled, (state, action) => {
        state.loadingOneTimeFee = false;
        state.coachOneTimeFee = action.payload;
      })
      .addCase(fetchCoachOneTimeFeeThunk.rejected, (state, action) => {
        state.loadingOneTimeFee = false;
        state.oneTimeFeeError = action.payload;
      });
  },
});
 
export default onboardingSlice.reducer;